export default function megabytesToBytes(size: number) {
  return size * 1e6;
}
